import { Col, DesignTokens, ValueOrFallback } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const { fonts, spacings, colors } = DesignTokens;

const DesignItemLabel = styled.div`
  font-family: ${fonts.sansSerifMd};
`;

const StyledCol = styled(Col)`
  padding: ${spacings.small}px 0;
  &:nth-child(odd) {
    border-right: 1px solid ${colors.gray.light};
  }
`;

type DesignInfoItemProps = {
  label: string;
  value?: string | React.ReactNode;
};

export const DesignInfoItem: React.FC<DesignInfoItemProps> = ({
  label,
  value,
}) => {
  const { t } = useTranslation();

  return (
    <StyledCol span={12}>
      <DesignItemLabel>{label}</DesignItemLabel>
      <ValueOrFallback value={value} fallback={t("global.fallback.none")} />
    </StyledCol>
  );
};
